/**
 * Shared Error Handling Package
 * 
 * Provides standardized error classes and utilities for the entire monorepo
 */

// Export all error classes
export * from './errors'

// Export error handler and utilities
export * from './handler'
export * from './utils'
export * from './types'

// Export convenience references
export { ErrorHandler as errorHandler } from './handler'
export { ErrorHandler } from './handler'

// Import needed types
import { AppError } from './errors'
import { ErrorHandler } from './handler'

// Helper function for backward compatibility
export const parseError = (error: unknown) => ErrorHandler.normalize(error)
export const isOperationalError = (error: AppError) => error.isOperational